import { useEffect, forwardRef, useImperativeHandle } from 'react';
// @mui
import { Box, Typography } from '@mui/material';
// utils
import getIcon from '../../../utils/getIcon';
//intl
import { useIntl } from 'react-intl';
// redux
import { useSelector } from '../../../redux/store';
//
import { showFidoRegistrationFragment, setActiveUser } from '../../../utils/FidoSDK';

// ----------------------------------------------------------------------

export default forwardRef(
  (
    {
      onNext,
      setDisabledHandleSubmit
    }: { onNext: () => void; setDisabledHandleSubmit: (value: boolean) => void },
    ref: any
  ) => {
    const intl = useIntl();
    const handleSubmit = () => {
      onNext();
    };

    const { user, sessionData, response, platform_security } = useSelector(
      (state) => state.nuDetectState
    );

    useImperativeHandle(ref, () => ({
      onHandleSubmit: handleSubmit
    }));

    useEffect(() => {
      setDisabledHandleSubmit(true);
      if (platform_security == 'BiometricAuthenticationService') {
        if (user && sessionData) {
          setActiveUser(user.username);
          showFidoRegistrationFragment(
            user.username,
            sessionData.sessionKey,
            () => {},
            (withGo: boolean = false) => {
              if (withGo) {
                // const registeredUsersBas = JSON.parse(localStorage.getItem('registered-users-bas') || '[]')
                // if (!registeredUsersBas.includes(user.username)) {
                //   registeredUsersBas.push(user.username)
                // }
                // localStorage.setItem('registered-users-bas', JSON.stringify(registeredUsersBas));
                onNext();
              }
            },
            () => {}
          );
        }
      }
      // eslint-disable-next-line
    }, []);

    return (
      <Box>
        <Box width={24} height={24} mx="auto" mb={2} color={(theme) => theme.palette.success.main}>
          {getIcon('ic_done_light')}
        </Box>

        <Typography
          variant="subtitle2"
          textAlign="center"
          fontFamily="Roboto"
          color={(theme) => theme.palette.grey[900]}
          maxWidth={160}
          mx="auto"
        >
          {intl.formatMessage({
            id: 'sign-up-access.texto-11',
            defaultMessage: 'YOUR ACCOUNT HAS BEEN ACTIVATED'
          })}
        </Typography>

        {platform_security == 'BiometricAuthenticationService' && (
          <div id="fido-reg-methods-fido2"></div>
        )}
      </Box>
    );
  }
);
